<footer *ngFor="let item of data" class="bg-sigma-bar">
    <div class="flex flex-row items-center justify-center w-full h-full py-2">
        <!-- <div class="hidden w-1/2 h-full ml-10 md:flex">
            <a class="" [href]="'/home'">
                <picture>
                    <source class="h-10" type="image/webp" [attr.defaultImage]="item.logo +'.webp'"
                        [attr.lazyLoad]="item.logo +'.webp'" />
                    <img class="h-10" [defaultImage]="item.logo +'.png'" [lazyLoad]="item.logo +'.png'" />
                </picture>
            </a>
        </div> -->
        <div class="w-full h-full mr-0 text-center md:mr-10 md:text-right md:w-max">
            <p class="w-full text-xl font-semibold text-gray-800">© {{ brand.footerLegalName }} {{ year }} — Todos los derechos reservados
            </p>
        </div>
    </div>
</footer>